import React from 'react';
import { ReactComponent as SunriseIcon } from '../../assets/icons/SunriseIcon.svg';
import { ReactComponent as SunsetIcon } from '../../assets/icons/SunsetIcon.svg';
import { ReactComponent as HumidityIcon } from '../../assets/icons/HumidityIcon.svg';
import { ReactComponent as UvIndexIcon } from '../../assets/icons/UvIndexIcon.svg';
import { ReactComponent as WindTurbineIcon } from '../../assets/icons/WindTurbineIcon .svg';
import { ReactComponent as LocationMarkerIcon } from '../../assets/icons/LocationMarkerIcon.svg';

const ICONS = {
  sunrise: SunriseIcon,
  sunset: SunsetIcon,
  humidity: HumidityIcon,
  uvIndex: UvIndexIcon,
  windTurbine: WindTurbineIcon,
  locationMarker: LocationMarkerIcon,
};

const Icon = ({ name, className, ...props }) => {
  const IconComponent = ICONS[name];
  if (!IconComponent) {
    console.warn(`Icon "${name}" nicht gefunden.`);
    return null;
  }
  return <IconComponent className={className} {...props} />;
};

export default Icon;


// Nutzen der Icon-Komponente: 
// Alle Icons werden in ein Objekt (ICONS) gemappt 
// einfache Nutzung :     <Icon name="sunrise" />